<template>
  <b-card>
    <validation-observer ref="editClient">
      <b-form
          class="mt-2"
          @submit.prevent="handleSubmit"
          @keydown.enter="handleSubmit"
      >
        <b-row>
          <b-col cols="12">
            <h4 class="mb-2">Detalles cliente</h4>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="Nombre"
                rules="required"
            >
              <b-form-group
                  label="Nombre"
                  label-for="client-name"
              >
                <b-form-input
                    v-model="client.name"
                    name="name"
                    placeholder="Nombre"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>

          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="CIF"
                rules="required"
            >
              <b-form-group
                  label="CIF"
                  label-for="client-cif"
              >
                <b-form-input
                    v-model="client.cif"
                    name="reference"
                    placeholder="CIF"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider #default="{ errors }" name="Dirección">
              <b-form-group label="Dirección" label-for="client-address">
                <b-form-input
                  v-model="client.address"
                  name="reference"
                  placeholder="Dirección"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="Código postal"
            >
              <b-form-group
                  label="Código postal"
                  label-for="client-postalCode"
              >
                <b-form-input
                    v-model="client.postalCode"
                    name="reference"
                    placeholder="Código postal"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="Región"
            >
              <b-form-group
                  label="Región"
                  label-for="client-region"
              >
                <b-form-input
                    v-model="client.region"
                    name="reference"
                    placeholder="Región"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="País"
            >
              <b-form-group
                  label="País"
                  label-for="client-country"
              >
                <b-form-input
                    v-model="client.country"
                    name="reference"
                    placeholder="País"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="Ciudad"
            >
              <b-form-group
                  label="Ciudad"
                  label-for="client-city"
              >
                <b-form-input
                    v-model="client.city"
                    name="reference"
                    placeholder="Ciudad"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="Teléfono"
            >
              <b-form-group
                  label="Teléfono"
                  label-for="client-phone"
              >
                <b-form-input
                    v-model="client.phone"
                    name="reference"
                    placeholder="Teléfono"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="Email"
                rules="email"
            >
              <b-form-group
                  label="Email"
                  label-for="client-email"
              >
                <b-form-input
                    v-model="client.email"
                    name="reference"
                    placeholder="Email"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                name="Web"
            >
              <b-form-group
                  label="Web"
                  label-for="client-web"
              >
                <b-form-input
                    v-model="client.web"
                    name="reference"
                    placeholder="Web"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="12">
            <b-form-group
                label="Imagen"
                label-for="client-image"
            >
              <ImageDropzone
                  v-if="clientPrepare"
                  ref="image"
                  :files="files"
                  max-files="1"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12 text-right">
            <b-button
                type="submit"
                variant="primary"
                class="mt-2 mr-1"
            >
              Enviar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormCheckbox
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import ImageDropzone from '@/components/elements/ImageDropzone/ImageDropzone.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    ImageDropzone,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      files: [],
      required,
      email,
      clientPrepare: false,
    }
  },
  computed: {
    ...mapGetters({
      client: 'clients/getClient',
      currentClient: 'clients/getCurrentClient',
      role: 'auth/getRole',
    }),
  },
  methods: {
    ...mapActions({
      edit: 'clients/edit',
      getClient: 'clients/getClient',
    }),
    handleSubmit() {
      this.$refs.editClient.validate().then(success => {
        if (success) {
          const { id } = this.client
          const formData = this.createFormData()
          if (formData) {
            this.edit({ id, client: formData })
          }
        }
      })
    },
    setData() {
      if (this.client.image) {
        const file = {
          name: 'Image',
          url: this.client.image.path,
          urlDelete: `/clients/delete_image/${this.client.id}`,
        }
        this.files.push(file)
      }

      this.clientPrepare = true
    },
    createFormData() {
      const data = this.$refs.image.getFormData('image')

      console.log(this.client);

      data.append('name', this.client.name)
      if (this.role === 'super_admin') {
        data.append(
            'show_assets',
            this.client.show_assets ? 1 : 0,
        )
        data.append(
            'show_epis',
            this.client.show_epis ? 1 : 0,
        )
        data.append(
            'show_installations',
            this.client.show_installations ? 1 : 0,
        )
      }


      data.append('cif', this.client.cif ? this.client.cif : '')
      data.append('address', this.client.address ? this.client.address : '')
      data.append(
          'postalCode',
          this.client.postalCode ? this.client.postalCode : '',
      )
      data.append('region', this.client.region ? this.client.region : '')
      data.append('country', this.client.country ? this.client.country : '')
      data.append('city', this.client.city ? this.client.city : '')
      data.append('phone', this.client.phone ? this.client.phone : '')
      data.append('email', this.client.email ? this.client.email : '')
      data.append('web', this.client.web ? this.client.web : '')

      return data
    },
  },
  async created() {
    await this.getClient(this.currentClient.id)
    await this.setData()
  },
}
</script>
